import { render } from "./DeliveryLocationSelect.vue?vue&type=template&id=566b30b1"
import script from "./DeliveryLocationSelect.vue?vue&type=script&lang=js"
export * from "./DeliveryLocationSelect.vue?vue&type=script&lang=js"

import "./DeliveryLocationSelect.vue?vue&type=style&index=0&id=566b30b1&lang=css"
script.render = render

export default script